import * as React from 'react';
import { GoogleAppStoreSettings, GooglePlayStoreState } from '../types';
import { antGrey, releaseSettingsDescriptionsStyle } from './styles/globalStyles';
import GooglePlayStoreReleaseSettingsDescriptions from './appSettings/GooglePlayStoreReleaseSettingsDescriptions';
import { Nullable, ReleaseComponentProps, StepRunComponentProps } from '../typescriptHelpers';
import {
    selectAppStoreDefaults,
    selectIsSubmitAutomationInactiveMissingAppStoreDefaults,
} from '../selectors/selectors';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';

interface AndroidAppStoreReleaseSettingsProps extends ReleaseComponentProps {
    releaseSettings?: GoogleAppStoreSettings;
    googlePlayStoreState?: GooglePlayStoreState;
    isReleaseRollback: boolean;
    storeUrl: string;
    onShowAppStoreReleaseSettings: () => void;
    autoStagedRolloutAutomationId: Nullable<string>;
    stepRunComponentProps: Nullable<StepRunComponentProps>;
}

export const AndroidAppStoreReleaseSettingsBase: React.FC<AndroidAppStoreReleaseSettingsProps> = (props) => {
    const isSubmitAutomationDisabledMissingDefaults = useSelector((state: RootState) => {
        if (props.releaseId) {
            return selectIsSubmitAutomationInactiveMissingAppStoreDefaults(state, props.appId, props.releaseId);
        } else {
            return false;
        }
    });

    const appStoreDefaults = useSelector((state: RootState) => selectAppStoreDefaults(state, props.appId));

    return (
        <GooglePlayStoreReleaseSettingsDescriptions
            orgId={props.orgId}
            appId={props.appId}
            releaseId={props.releaseId}
            autoStagedRolloutAutomationId={props.autoStagedRolloutAutomationId}
            isRollback={props.isReleaseRollback}
            labelStyle={{ ...releaseSettingsDescriptionsStyle, marginTop: 12 }}
            contentStyle={{ color: antGrey.grey7, marginTop: 12 }}
            isSubmitAutomationDisabledMissingDefaults={isSubmitAutomationDisabledMissingDefaults ?? false}
            appDefaultSettings={appStoreDefaults as GoogleAppStoreSettings}
            releaseSettings={props.releaseSettings}
            stepRunComponentProps={props.stepRunComponentProps}
        />
    );
};
